import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'environments/environment';

export const DevModeGuard: CanActivateFn = () => {
    if (!environment.production) {
        return true;
    }

    return inject(Router).parseUrl('/acceso-denegado');
};
